import http from "@/http-common";

class dashboardService {
   getDashboardDetails(customerId) {
      return http.get("/customer/" + customerId + '/dashboard').then((res) => {
         return res.data;
      });
   }
}

export default new dashboardService();
